import { render, staticRenderFns } from "./productHistory.vue?vue&type=template&id=b6ca303c"
import script from "./productHistory.vue?vue&type=script&lang=js"
export * from "./productHistory.vue?vue&type=script&lang=js"
import style0 from "./productHistory.vue?vue&type=style&index=0&id=b6ca303c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports